import '../style/yearpage.css';
import { useNavigate } from 'react-router-dom';
import BaliImage from '../components/bali.webp';
import CroatiaImage from '../components/croatia.webp';

function Year2020() {
    const navigate = useNavigate(); // Initialize the navigate function
  
    // Function to handle container clicks
    const handleContainerClick = (path) => {
      navigate(path); // Navigate to the specified path
    };

    const handleBackClick = () => {
      navigate('/'); // Navigate to the home page
    };
  
    return (
      <div className="year-page">
        <h1>2020 Photos</h1>
        <button 
        className="back-button" 
        onClick={handleBackClick}
      >
        ← Back 
      </button>
        <div className="location-grid">
          {/* Bali Location */}
          <div
            className="location-container"
            onClick={() => handleContainerClick('/bali')} // Redirect to /bali
            style={{ cursor: 'pointer' }} // Add pointer cursor to indicate clickability
          >
            <div
              className="image-container"
              style={{ backgroundImage: `url(${BaliImage})` }}
            ></div>
            <p className="location-name">Bali</p>
          </div>
  
          {/* Croatia Location */}
          <div
            className="location-container"
            onClick={() => handleContainerClick('/croatia')} // Redirect to /croatia
            style={{ cursor: 'pointer' }} // Add pointer cursor to indicate clickability
          >
            <div
              className="image-container"
              style={{ backgroundImage: `url(${CroatiaImage})` }}
            ></div>
            <p className="location-name">Croatia</p>
          </div>
        </div>
      </div>
    );
  }
  
  export default Year2020;